import { RENDER_TOAST, HIDE_TOAST, HIDE_ALL_TOASTS } from './actions';
const INITIAL_STATE = [];
export function toastReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case RENDER_TOAST: {
            const { id } = action.payload;
            return [...state, id];
        }
        case HIDE_TOAST: {
            const { id } = action.payload;
            return state.filter(stateId => stateId !== id);
        }
        case HIDE_ALL_TOASTS: {
            return [];
        }
        default:
            return state;
    }
}
//# sourceMappingURL=reducer.js.map